import { ROLE_EXPERT } from '../../store/constants';

export const getUserRole = (state) => {
    return state?.user?.roles[0]?.roleName;
}

export const isExpertRole = (state) => {
    return getUserRole(state) === ROLE_EXPERT;
}
